import AddAndEditBannerImagePage from "../../../../features/admin/banner-images/add-and-edit-banner-image-page/add-and-edit-banner-image-page";

export default function AddAndEditBannerImage({ isEdit }: { isEdit: boolean }) {
  return <AddAndEditBannerImagePage isEdit={isEdit} />;
}
